<script lang="ts">
  import recap, {Timestamp, TimestampText} from '@/store/recap';
  import {createEventDispatcher, onDestroy} from 'svelte';

  const dispatch = createEventDispatcher();

  export let selectedTranscriptions: TimestampText[] = [];

  let aiSuggestedIntro: {
    title: string;
    duration: number;
    text: string;
    startDuration: number;
    endDuration: number;
  }[] = [];

  function seconds2time(seconds: number) {
    return new Date(seconds * 1000).toISOString().substring(11, 16);
  }

  let minimumTextLength = 256;
  let readMoreIndex = -1;

  const recapSubscription = recap.subscribe(value => {
    aiSuggestedIntro = ((Array.isArray(value.suggested_intros) && value.suggested_intros) || [])
      .filter(intro => {
        return typeof intro === 'object' && typeof intro.topic === 'string' && typeof intro.text === 'string';
      })
      .map(intro => {
        const timestamps: TimestampText[] = [];
        const textArray = intro.text.split(' ');

        const firstText = textArray[0];
        const secondText = textArray[1];
        const secondLastText = textArray[textArray.length - 2];
        const lastText = textArray[textArray.length - 1];

        if (selectedTranscriptions.length <= 0) {
          const transcriptions = value.transcription || [];
          const timestamps = value.timestamps || [];

          for (let i = 0; i < transcriptions.length; i++) {
            const transcription = transcriptions[i];
            if (!transcription) continue;

            for (let j = 0; j < timestamps.length; j++) {
              const timestamp = timestamps[j];
              if (!timestamp) continue;

              if (
                transcription.timeStart >= timestamp.startDuration &&
                transcription.timeEnd <= timestamp.endDuration
              ) {
                selectedTranscriptions.push(transcription);
              }
            }
          }
        }

        for (let i = 1; i < selectedTranscriptions.length; i++) {
          const text = selectedTranscriptions[i - 1].text;
          const nextText = selectedTranscriptions[i].text;

          if (text === firstText && nextText === secondText) timestamps.push(selectedTranscriptions[i - 1]);
          if (text === secondLastText && nextText === lastText) timestamps.push(selectedTranscriptions[i]);
        }

        return {
          title: intro.topic || '',
          text: intro.text || '',
          duration: timestamps[timestamps.length - 1].timeEnd - timestamps[0].timeStart,
          startDuration: timestamps[0].timeStart,
          endDuration: timestamps[timestamps.length - 1].timeEnd
        };
      });
  });

  onDestroy(() => {
    recapSubscription();
  });
</script>

<div class="h-full w-full overflow-hidden p-4" style="max-width: 540px;">
  <div>
    <h1 class="text-xl font-bold">AI Suggested Intros</h1>
  </div>
  <div class="flex h-full flex-col gap-4 overflow-auto py-4">
    {#each aiSuggestedIntro as intro, index}
      <button
        on:click={() =>
          dispatch('selected-intro', {startDuration: intro.startDuration, endDuration: intro.endDuration})}
        class="rounded-lg border py-4"
      >
        <div class="w-full border-b px-4 pb-2">
          <h1 class="text-start text-xl font-bold">{intro.title}</h1>
        </div>
        <div class="px-4 py-2 text-start text-sm text-zinc-500">
          Duration: {seconds2time(intro.duration)}
        </div>
        <div class="px-4 pb-4 text-start text-sm text-zinc-800">
          {#if readMoreIndex !== index}
            {intro.text.length > minimumTextLength - 3
              ? `${intro.text.substring(0, minimumTextLength)}...`
              : intro.text}
          {:else}
            {intro.text}
          {/if}
        </div>
        <button
          on:click={() => (readMoreIndex = readMoreIndex === index ? -1 : index)}
          class="flex items-center gap-1 px-4 text-sm text-rose-500"
        >
          Read {readMoreIndex === index ? 'Less' : 'More'}
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </button>
    {/each}
  </div>
</div>
